
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 13V7.5a.5.5 0 011 0V13c0 .563.438 1 1 1h6v-3.5A1.5 1.5 0 0110.5 9H14V3c0-.531-.469-1-1-1H7.5a.5.5 0 010-1H13c1.094 0 2 .906 2 2v6.188c0 .53-.219 1.03-.594 1.406l-3.844 3.844A1.959 1.959 0 019.156 15H3c-1.125 0-2-.875-2-2zm12.563-3H10.5c-.281 0-.5.25-.5.5v3.094L13.563 10zM6 3.5c0 .281-.25.5-.5.5H4v1.5c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5V4H1.5a.494.494 0 01-.5-.5c0-.25.219-.5.5-.5H3V1.5c0-.25.219-.5.5-.5.25 0 .5.25.5.5V3h1.5c.25 0 .5.25.5.5z","fill":"#000"}})])
          )
        }
      }
    